import type { Marketplace } from "@wbly/common";
import { isBrowser } from "@wbly/common";

export function getMarketplace() {
  if (!isBrowser()) {
    throw new Error(
      `Get marketplace cannot be used serverside!
Either use the MarketplaceContext for react components, or Astro.locals.marketplace for server-side Astro components.`
    );
  }
  const script = document.querySelector("script[data-marketplace]");
  const marketplace = JSON.parse(script.textContent);
  return marketplace as Marketplace;
}
